import { Currency, LanguageConfig } from './language.config';

export class EnglishConfig extends LanguageConfig {
  constructor() {
    super();
    this.units = [
      '',
      'One',
      'Two',
      'Three',
      'Four',
      'Five',
      'Six',
      'Seven',
      'Eight',
      'Nine',
    ];
    this.teens = [
      'Ten',
      'Eleven',
      'Twelve',
      'Thirteen',
      'Fourteen',
      'Fifteen',
      'Sixteen',
      'Seventeen',
      'Eighteen',
      'Nineteen',
    ];
    this.tens = [
      '',
      'Ten',
      'Twenty',
      'Thirty',
      'Forty',
      'Fifty',
      'Sixty',
      'Seventy',
      'Eighty',
      'Ninety',
    ];
    this.scales = ['', 'Thousand', 'Million', 'Billion'];
    this.zeroWord = 'Zero';
    this.decimalConnector = 'and';
    this.currencyPluralization = (
      currency: Currency,
      amount: number,
    ): string => {
      if (amount !== 1) {
        if (currency === 'Franc CFA') return 'Francs CFA';
      }
      return amount > 1 ? currency + 's' : currency;
    };
    this.fractionalUnit = (currency: Currency, amount: number): string => {
      return amount !== 1 ? 'Cents' : 'Cent';
    };
  }

  protected getHundreds(hundreds: number): string {
    return `${this.units[hundreds]} Hundred`;
  }
}
